import { forwardRef } from "react";
import { cn } from "../../../helpers/cn";

/**
 * @typedef {React.HTMLProps<HTMLSelectElement>} SelectProps
 * @typedef {React.HTMLProps<HTMLLabelElement>} LabelProps
 * @typedef {React.HTMLProps<HTMLDivElement>} HelperTextProps
 */

/**
 * @typedef {Object} CustomSelectProps
 * @property {string} [label]
 * @property {boolean} [isError]
 * @property {string} [helperText]
 * @property {LabelProps} [labelProps]
 * @property {HelperTextProps} [helperTextProps]
 */

/**
 * @typedef {SelectProps & CustomSelectProps} ExtendedSelectProps
 */

/**
 * @param {ExtendedSelectProps} props
 */

function Select(
  {
    label,
    id,
    className,
    isError = false,
    required = false,
    helperText,
    children,
    labelProps = {},
    helperTextProps = {},
    ...rest
  },
  ref
) {
  const { className: labelClassName, ...labelRest } = labelProps;
  const { className: helperTextClassName, ...helperTextRest } = helperTextProps;

  return (
    <div className="tw-flex tw-flex-col">
      {label && (
        <label
          className={cn(
            `${isError ? "tw-text-red-500 focus:tw-border-red-400" : ""}`,
            labelClassName
          )}
          htmlFor={id}
          {...labelRest}
        >
          {label} {required && <span className="tw-text-red-500">*</span>}
        </label>
      )}

      <select
        className={cn(
          `form-control ${
            isError ? "tw-border-red-500 focus:tw-border-red-500" : ""
          }`,
          className
        )}
        ref={ref}
        {...rest}
      >
        {children}
      </select>

      {helperText && (
        <small
          className={cn(
            `tw-mt-1 tw-m-0 ${isError ? "tw-text-red-500" : ""}`,
            helperTextClassName
          )}
          {...helperTextRest}
        >
          {helperText}
        </small>
      )}
    </div>
  );
}

export default forwardRef(Select);
